import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "base-tag__icon-wrapper" }
const _hoisted_2 = { class: "base-tag__text" }




export default /*@__PURE__*/_defineComponent({
  __name: 'BaseTag',
  props: {
    round: { type: Boolean },
    showIcon: { type: Boolean },
    strongText: { type: Boolean },
    whiteTextColor: { type: Boolean },
    background: { default: '#F2F4F5' }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["BaseTag base-tag", {'is--round': _ctx.round, 'is--white-text': _ctx.whiteTextColor, 'is--strong-text': _ctx.strongText, 'is--icon': _ctx.showIcon}]),
    style: _normalizeStyle({ background: _ctx.background })
  }, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "icon")
    ]),
    _createElementVNode("p", _hoisted_2, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ], 6))
}
}

})